export class ForBusiness {
  id!:string;
  name!:string;
  email!:string;
  phoneno!:string;
  alternativeno!:string;
  aadharno!:string;
  address!:string;
  approvalstage:string = "Requested";
}
